import { useCallback, useEffect, useState } from 'react'

import useBounce from '../hooks/useBounce'
import BounceLeaderboard from '../components/BounceLeaderboard'
import BounceCountdown from '../components/BounceCountdown'

const Space = ({ r, c, board, target }) => {
  // Check if this space is the target
  const isTarget = target && target.position[0] === r && target.position[1] === c
  
  const hasColor = board.find(p => {
    const parts = p.split('-')
    const space = [parts[0], parts[1]].join('-')
    if (space === `${r}-${c}`) {
      return true
    } else {
      return false
    }
  })
  
  const bgColor = isTarget ? 'gold' : (hasColor ? hasColor.split('-')[2] : 'white')
  
  return (
    <td>
      <div style={{ 
        border: '1px solid black', 
        backgroundColor: bgColor, 
        height: 25, 
        width: 25,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px',
        lineHeight: '25px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        position: 'relative'
      }}>
        {isTarget && (
          <span style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '16px'
          }}>
            ⭐
          </span>
        )}
      </div>
    </td>
  )
}

const Bounce = () => {
  const [, setJoined] = useState(false)

  const { leave, data, move, join, target, resetTime } = useBounce()

  useEffect(() => {
    function handleKeyDown (e) {
      move(e.keyCode)
    }

    document.addEventListener('keydown', handleKeyDown)

    return function cleanup () {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [data, move])

  const start = useCallback(() => {
    setJoined(true)
    join()
  }, [join])

  const stop = useCallback(() => {
    setJoined(false)
    leave()
  }, [leave])

  const board = data ? Object.keys(data).map(uid => {
    return `${data[uid][0]}-${data[uid][1]}-${data[uid][2]}`
  }) : []

  function createArray (n) {
    return Array.from({ length: n }, (_, i) => i + 1)
  }

  return (
    <div>
      <button onClick={start}>Join</button>
      <button onClick={stop}>Leave</button>
      <BounceCountdown resetTime={resetTime} />
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div>
          <table>
            {createArray(30).map((r, rIdx) => {
              return (
                <tr key={`row_${rIdx}`}>{createArray(30).map((c, cIdx) => {
                  return <Space key={`space_${rIdx}_${cIdx}`} r={rIdx} c={cIdx} board={board} target={target} />
                })}
                </tr>
              )
            })}
          </table>
        </div>
        <BounceLeaderboard players={data || {}} />
      </div>
    </div>
  )
}

export default Bounce
